import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../helpers/axiosConfig";

export const registerAccount = createAsyncThunk(
    'account/registerAccount',
    async ({ user, navigate }, { rejectWithValue }) => {
        try {
            const accountData = new FormData();
            accountData.append('email', user.email);
            accountData.append('password', user.password);
            accountData.append('password2', user.password2);
            accountData.append('gender', user.gender);
            accountData.append('region', user.region);
            accountData.append('date', user.date);
            const res = await api.post(`/users/register/`, accountData);
            if (res.status === 201) {
                return { res, navigate, user };
            }
        } catch (err) {
            if (err.response.data.email) {
                return rejectWithValue(err.response.data.email[0]);
            } else {
                return "Ошибка при регистрации"
            }
        }
    }
);

export const confirmAccount = createAsyncThunk(
    'account/confirmAccount',
    async ({ verificationCode, navigate }, { rejectWithValue }) => {
        try {
            const keyData = new FormData();
            keyData.append('code', verificationCode);
            const res = await api.post(`/users/confirm/`, keyData);
            if (res.status === 200) {
                return { res, navigate }
            }
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const resendCodeForConfirm = createAsyncThunk(
    'account/resendCodeForNewPassword',
    async ({ emailToSubmit }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('email', emailToSubmit);
            const res = await api.post(`/users/resend_code/`, formData);
            if (res.status === 201) {
                return { res }
            }
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
)

export const getUserData = createAsyncThunk(
    'account/getUserData',
    async () => {
        try {
            const { data } = await api.get("/users/profile/");
            return { data };
        } catch (err) {
            throw err;
        }
    }
);

export const getUserStatusData = createAsyncThunk(
    'account/getUserStatusData',
    async () => {
        try {
            const { data } = await api.get("/users/profile/");
            return { data };
        } catch (err) {
            throw err;
        }
    }
)

export const loginAccount = createAsyncThunk(
    'account/loginAccount',
    async ({ user, navigate }, { rejectWithValue }) => {
        try {
            const accountData = new FormData();
            accountData.append('email', user.email);
            accountData.append('password', user.password);
            const res = await api.post("/users/login/", accountData);
            if (res.status === 200) {
                return { res, navigate, user };
            }
        } catch (err) {
            if (err.response.data.detail) {
                return rejectWithValue(err.response.data.detail);
            } else if (err.response.data.error) {
                return rejectWithValue(err.response.data.error);
            } else if (err.response.message) {
                return rejectWithValue(err.response.message);
            } else {
                return rejectWithValue("Не удалось войти в аккаунт")
            }
        }
    }
);

export const changePassword = createAsyncThunk(
    'account/changePassword',
    async (password, thunkAPI) => {
        try {
            const accountData = new FormData();
            accountData.append('old_password', password.old_password);
            accountData.append('new_password1', password.new_password1);
            accountData.append('new_password2', password.new_password2);
            const { data } = await api.patch(`/users/change_password/`, accountData);
            return { data };
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message && err.response.data.message[0] === "Старый пароль неверный") {
                return thunkAPI.rejectWithValue(err.response.data.message[0]);
            }
        }
    }
);

export const changeEmail = createAsyncThunk(
    'account/changeEmail',
    async (email) => {
        try {
            const emailData = new FormData();
            emailData.append('email', email.new_email);
            const res = await api.post(`/email/`, emailData);
            if (res.status === 200) {
                alert(res.data);
                return email.new_email;
            }
        } catch (err) {
        }
    }
);

export const confirmEmailChange = createAsyncThunk(
    'account/confirmEmailChange',
    async ({ verificationCode, navigate }) => {
        try {
            const { data } = await api.get(`/user/${verificationCode}/`);
            if (data.message === "Email подтвержден") {
                alert('Email подтвержден');
                return { navigate };
            }
        } catch (err) {
        }
    }
)

export const updateProfile = createAsyncThunk(
    'account/updateProfile',
    async ({ profile, navigate }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };
            const profileData = new FormData();
            if (profile.image instanceof File) {
                profileData.append('image', profile.image);
            }
            profileData.append('first_name', profile.first_name);
            profileData.append('last_name', profile.last_name);
            profileData.append('gender', profile.gender);
            profileData.append('date', profile.date);
            profileData.append('region', profile.region);
            const res = await api.patch(`/users/profile/update/`, profileData, config);
            if (res.status === 200) {
                return { res, navigate }
            }
        } catch (err) {
            return rejectWithValue(err.response.data)
        }
    }
);


export const sendEmail = createAsyncThunk(
    'account/sendEmail',
    async ({ email, navigate }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('email', email);
            const res = await api.post(`/users/password_reset/`, formData);
            if (res.status === 201) {
                return { email, navigate }
            }
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
)

export const sendCodeForNewPassword = createAsyncThunk(
    'account/sendCodeForNewPassword',
    async ({ code, navigate }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('code', code);
            const res = await api.post('/users/password_reset/code/', formData);
            if (res.status === 200) {
                return { res, navigate }
            }
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
)

export const resendCodeForNewPassword = createAsyncThunk(
    'account/resendCodeForNewPassword',
    async ({ email }) => {
        try {
            const formData = new FormData();
            formData.append('email', email);
            const res = await api.post(`/users/resend_code/`, formData);
            if (res.status === 200) {
                return res.data;
            }
        } catch (err) {
            throw err;
        }
    }
)

export const sendNewPassword = createAsyncThunk(
    'account/sendNewPassword',
    async ({ password, navigate }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('new_password1', password.new_password);
            formData.append('new_password2', password.password_submit);
            const res = await api.put(`/users/password_reset/confirm/`, formData);
            if (res.status === 200) {
                return { res, navigate }
            }
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const logoutAccount = createAsyncThunk(
    'account/logoutAccount',
    async () => {
        try {
            const res = await api.post("/users/logout_all/");
        } catch (err) {
        }
    }
)

export const sendSMS = createAsyncThunk(
    'account/sendSMS',
    async ({ phone_number }, { rejectWithValue }) => {
        try {
            const smsData = new FormData();
            smsData.append('phone_number', phone_number);
            const res = await api.post("/users/send-sms/", smsData);
            if (res.status === 200) {
                return res.data;
            }
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || "Failed to send SMS");
        }
    }
);

export const verifyCode = createAsyncThunk(
    'account/verifyCode',
    async ({ code }, { rejectWithValue }) => {
        try {
            const codeData = new FormData();
            codeData.append('code', code);
            const res = await api.post("/users/verify-code/", codeData);
            if (res.status === 200) {
                return res.data;
            }
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || "Failed to verify code");
        }
    }
);

export const checkPhoneNumber = createAsyncThunk(
    'account/checkPhoneNumber',
    async ({ phone_number }, { rejectWithValue }) => {
        try {
            const phoneData = new FormData();
            phoneData.append('phone_number', phone_number);
            const res = await api.post("/users/check-phone/", phoneData);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || "Phone number already exists");
        }
    }
);